import {BillingSource, useBillingUser} from '@common/billing/billing-page/use-billing-user';
import {useTenantBilling} from '@common/billing/billing-page/use-tenant-billing';
import {ReactNode, createContext, useContext} from 'react';

export type BillingProviderMode = 'user' | 'tenant';

interface BillingDataProviderProps {
  mode?: BillingProviderMode;
  children: ReactNode;
}

const BillingDataContext = createContext<BillingSource | null>(null);

export function BillingDataProvider({mode = 'user', children}: BillingDataProviderProps) {
  const userBilling = useBillingUser();
  const tenantBilling = useTenantBilling();
  
  const value = mode === 'tenant' ? tenantBilling : userBilling;
  
  return (
    <BillingDataContext.Provider value={value}>{children}</BillingDataContext.Provider>
  );
}

export function useBillingData(): BillingSource {
  const ctx = useContext(BillingDataContext);
  if (!ctx) {
    // If not within provider, return a default user billing source
    // This allows pricing page to work without being wrapped in provider
    return {
      subscription: undefined,
      isLoading: false,
      source: 'user',
    };
  }
  return ctx;
}
